import { render, staticRenderFns } from "./ChangeUserStatusModal.vue?vue&type=template&id=6f0dba1b&"
import script from "./ChangeUserStatusModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeUserStatusModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports